var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8727 13.875H3.56251C3.45939 13.875 3.37501 13.9594 3.37501 14.0625V15.4688C3.37501 15.5719 3.45939 15.6562 3.56251 15.6562H17.7469L14.3649 19.9453C14.2688 20.0672 14.3555 20.25 14.5125 20.25H16.2117C16.3266 20.25 16.4344 20.1984 16.507 20.107L20.4633 15.0891C20.85 14.5969 20.5008 13.875 19.8727 13.875ZM20.4375 8.34375H6.25314L9.63517 4.05469C9.73126 3.93281 9.64454 3.75 9.48751 3.75H7.78829C7.67345 3.75 7.56564 3.80156 7.49298 3.89297L3.53673 8.91094C3.15001 9.40313 3.49923 10.125 4.12501 10.125H20.4375C20.5406 10.125 20.625 10.0406 20.625 9.9375V8.53125C20.625 8.42812 20.5406 8.34375 20.4375 8.34375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIcon);
export default __webpack_public_path__ + "static/media/arrows-icon.3ec991d033e773eeb336d0d8f73737c0.svg";
export { ForwardRef as ReactComponent };